import { deepClone } from '@app/core/utilities/object.utilities';
import { addDays, addMonths, format } from 'date-fns';
import {
  AlertChannel,
  AlertDefinition,
  AlertMenuType,
  AlertMuteInfo,
  AlertTableFilter,
  ApolloPayload,
  EmailPayload,
} from './alert-settings.model';

export function getUntil(type: AlertMenuType) {
  switch (type) {
    case 'mute-indef':
      return null;
    case 'mute-month':
      return format(addMonths(new Date(), 1), 'yyyy-MM-dd');
    case 'mute-week':
      return format(addDays(new Date(), 7), 'yyyy-MM-dd');
  }
}

export function EmailMutePayloads(payload: EmailPayload[]) {
  const deletes = [];
  const edits = [];
  payload.forEach((d) => {
    if (!d.value) deletes.push({ definitionId: d.id, channel: AlertChannel.Email });
    else edits.push({ definitionId: d.id, channel: AlertChannel.Email, until: null });
  });
  return { deletes, edits };
}

export function ApolloMutePayloads(payload: ApolloPayload[]) {
  const deletes = [];
  const edits = [];
  payload.forEach((d) => {
    if (d.muteType === 'umute') deletes.push({ definitionId: d.id, channel: AlertChannel.Apollo });
    else edits.push({ definitionId: d.id, channel: AlertChannel.Apollo, until: getUntil(d.muteType) });
  });
  return { deletes, edits };
}

export function MutePayloadForBoth(payload: {
  [AlertChannel.Email]: EmailPayload[];
  [AlertChannel.Apollo]: ApolloPayload[];
}) {
  const { deletes, edits } = ApolloMutePayloads(payload[AlertChannel.Apollo]);
  const tmp = EmailMutePayloads(payload[AlertChannel.Email]);

  deletes.push(...tmp.deletes);
  edits.push(...tmp.edits);

  return { deletes, edits };
}

export function getNewMutes(res: any, mutes: AlertMuteInfo[]) {
  try {
    let newMutes = deepClone(mutes);
    if (res?.delete?.length)
      newMutes = newMutes.filter(
        (mute) => !res.delete.find((d) => mute.definitionId === d.definitionId && mute.channel === d.channel),
      );
    if (res?.create?.length) newMutes.push(...res.create);
    if (res?.update?.length)
      newMutes = newMutes.map((mute) => {
        const newMute = res.update.find((d) => mute.definitionId === d.definitionId && mute.channel === d.channel);
        return newMute ?? mute;
      });
    return newMutes;
  } catch (error) {
    debugger;
  }
}

export function getSelectedItems(definitions: AlertDefinition[], filters, mutes, value = false) {
  return getStatusFilteredDefinitions(filters, definitions, mutes).reduce((acc, d) => {
    if (d.severity !== 'CRITICAL') acc[d.definitionId] = value;
    return acc;
  }, {});
}
export function getStatusFilteredDefinitions(filters: any, definitions: AlertDefinition[], mutes: any) {
  let hasStatusFilter = filters?.[AlertTableFilter.Status]?.length === 1;
  const statusFilter = filters?.[AlertTableFilter.Status]?.[0];

  return definitions.filter((d) => {
    if (!hasStatusFilter) return true;
    else {
      if (statusFilter === 'mute') {
        return mutes.find((e) => e.definitionId === d.definitionId && e.channel === AlertChannel.Apollo);
      } else if (statusFilter === 'unmute') {
        return mutes.find((e) => !(e.definitionId === d.definitionId && e.channel === AlertChannel.Apollo));
      }
    }
  });
}
